'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./plan-choice-area-v2.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _smallToggle = require('common/components/small-toggle');

var _smallToggle2 = _interopRequireDefault(_smallToggle);

var _teamSizeSelect = require('./team-size-select');

var _teamSizeSelect2 = _interopRequireDefault(_teamSizeSelect);

var _planCard = require('./plan-card');

var _planCard2 = _interopRequireDefault(_planCard);

var _freePlanLink = require('./free-plan-link');

var _freePlanLink2 = _interopRequireDefault(_freePlanLink);

var _enterprisePlanCustomerCallout = require('./enterprise-plan-customer-callout');

var _enterprisePlanCustomerCallout2 = _interopRequireDefault(_enterprisePlanCustomerCallout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlanChoiceAreaV2 = function (_Component) {
    _inherits(PlanChoiceAreaV2, _Component);

    function PlanChoiceAreaV2() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PlanChoiceAreaV2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PlanChoiceAreaV2.__proto__ || Object.getPrototypeOf(PlanChoiceAreaV2)).call.apply(_ref, [this].concat(args))), _this), _this.toggleTime = function () {
            var value = void 0;
            if (_this.props.timePeriod === 'M') {
                value = 'Y';
            } else {
                value = 'M';
            }
            _this.props.onTimeToggle(value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PlanChoiceAreaV2, [{
        key: 'render',
        value: function render() {

            var teamSize = this.props.teamSize;
            var annual = this.props.timePeriod === 'Y';

            var toggleAreaMiddle = void 0;
            if (teamSize === 'large-team') {
                toggleAreaMiddle = _react2['default'].createElement(
                    'div',
                    { className: 'middle placeholder' },
                    _react2['default'].createElement('div', { className: 'line' })
                );
            } else {
                toggleAreaMiddle = _react2['default'].createElement(
                    'div',
                    { className: 'middle' },
                    _react2['default'].createElement(_smallToggle2['default'], {
                        on: annual,
                        onClick: this.toggleTime,
                        offLabel: 'MONTHLY',
                        onLabel: 'ANNUAL' })
                );
            }

            var timeToggleArea = void 0;
            if (teamSize) {
                timeToggleArea = _react2['default'].createElement(
                    'div',
                    { className: 'time-toggle-area' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'side' },
                        _react2['default'].createElement('div', { className: teamSize === 'individual' ? 'line pointer leftside' : 'line' })
                    ),
                    toggleAreaMiddle,
                    _react2['default'].createElement(
                        'div',
                        { className: 'side' },
                        _react2['default'].createElement('div', { className: teamSize === 'large-team' ? 'line pointer rightside' : 'line' })
                    )
                );
            }

            var planContent = void 0;
            var plans = void 0;
            switch (teamSize) {

                case 'individual':
                    plans = this.props.planData.filter(function (plan) {
                        return plan.name === 'Pro';
                    });
                    planContent = _react2['default'].createElement(
                        'div',
                        null,
                        _react2['default'].createElement(_planCard2['default'], {
                            plan: plans[0],
                            period: this.props.timePeriod,
                            onPlanChoice: this.props.onPlanChoice }),
                        _react2['default'].createElement(_freePlanLink2['default'], null)
                    );
                    break;

                case 'small-team':
                    plans = this.props.planData.filter(function (plan) {
                        return plan.name.indexOf('Business') > -1;
                    });
                    planContent = _react2['default'].createElement(
                        'div',
                        { className: 'two-up' },
                        _react2['default'].createElement(_planCard2['default'], {
                            plan: plans[0],
                            period: this.props.timePeriod,
                            onPlanChoice: this.props.onPlanChoice }),
                        _react2['default'].createElement(_planCard2['default'], {
                            plan: plans[1],
                            period: this.props.timePeriod,
                            onPlanChoice: this.props.onPlanChoice })
                    );
                    break;

                case 'large-team':
                    plans = this.props.planData.filter(function (plan) {
                        return plan.name === 'Enterprise';
                    });
                    planContent = _react2['default'].createElement(
                        'div',
                        { className: 'wide-card' },
                        _react2['default'].createElement(_planCard2['default'], {
                            plan: plans[0],
                            period: this.props.timePeriod,
                            onEnterpriseSuccess: this.props.onEnterpriseSuccess }),
                        _react2['default'].createElement(_enterprisePlanCustomerCallout2['default'], null)
                    );
                    break;

                default:
                // No content

            }

            return _react2['default'].createElement(
                'div',
                { className: 'plan-choice-area-v2' },
                _react2['default'].createElement(_teamSizeSelect2['default'], {
                    selected: teamSize,
                    onTeamSizeSelect: this.props.onTeamSizeSelect }),
                timeToggleArea,
                planContent
            );
        }
    }]);

    return PlanChoiceAreaV2;
}(_react.Component);

PlanChoiceAreaV2.propTypes = {
    planData: _react.PropTypes.array.isRequired,
    timePeriod: _react.PropTypes.string,
    teamSize: _react.PropTypes.string,
    onPlanChoice: _react.PropTypes.func,
    onEnterpriseSuccess: _react.PropTypes.func,
    onTimeToggle: _react.PropTypes.func,
    onTeamSizeSelect: _react.PropTypes.func
};
exports['default'] = PlanChoiceAreaV2;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/v2/plan-choice-area-v2.jsx
 ** module id = 1156
 ** module chunks = 0
 **/